import { createSlice } from "@reduxjs/toolkit";
import { Reducer } from "./Reducer";
import { InitialState, ParentOptOutModes } from "./Types";

// Initial state of ReportTabReducer
export const initialState: InitialState = {
  selectedOptOuts: [],
  mode: ParentOptOutModes.VIEW
};

// ReportTabSlice
export const Slice = createSlice({
  initialState,
  name: "optOut-reducer",
  reducers: Reducer,
});
